import React from 'react';
import { Helmet } from 'react-helmet-async';
import buildBreadcrumbList from '../helpers/buildBreadcrumbList.js';
import { array, string } from 'prop-types';

// The SEO component
// Used to integrate react-helmet-async in all routes in order to render dynamic meta tags
const SEO = ({ seoTitle, storeFaviconUrl, seoDescription, seoType, canonicalUrl, image, richSnippet, author, createdAt, updatedAt, pageContent, breadsArr }) => {
    // Calculate the estimated reading time of an article
    const estimatedReadingTime = (text = '') => {
        if (!text || typeof text !== 'string' || !text.length) 
            return 0;
        const wpm = 225;
        const words = text.trim().split(/\s+/).length;
        const time = Math.ceil(words / wpm);
        return time;
    };

    // Add the estimated reading time of an article to the SEO meta tag in case it has a description at all
    if (seoDescription && seoType === 'article') {
        seoDescription = `Estimated read time: ${estimatedReadingTime(pageContent)} minutes - ${seoDescription}`;
    }

    return (<Helmet>
        {/* Meta tags */}
        <title>{seoTitle}</title>
        {
            storeFaviconUrl && (
                <link
                    rel={'shortcut icon'}
                    href={storeFaviconUrl}></link>
            )
        } 
        {seoDescription && (<meta
            name={'description'}
            content={seoDescription} />)}
        {canonicalUrl && (<link
            rel={'canonical'}
            href={canonicalUrl} />)}
        {/* OG */}
        {canonicalUrl && (<meta
            property={'og:url'}
            content={canonicalUrl} />)}
        <meta
            property={'og:type'}
            content={seoType || 'website'} />
        <meta
            property={'og:title'}
            content={seoTitle} />
        <meta
            property={'og:site_name'}
            content={process.env.STORE_NAME} />
        <meta
            property={'twitter:title'}
            content={seoTitle} />
        {seoDescription && (<meta
            property={'og:description'}
            content={seoDescription} />)}
        {seoDescription && (<meta
            property={'twitter:description'}
            content={seoDescription} />)}
        {image && (<meta
            property={'og:image'}
            content={image} />)}
        {image && (<meta
            property={'twitter:image'}
            content={image} />)}
        {image && (<meta
            property={'og:image:width'}
            content={'200'} />)}
        {/* Rich snippets */}
        {(richSnippet) && (
            <script
                type={'application/ld+json'}>{richSnippet}</script>
        )}
        {(breadsArr && breadsArr.length > 0) && (
            <script
                type={'application/ld+json'}>{buildBreadcrumbList(breadsArr)}</script>
        )}
        {seoType === 'article' && (<meta
            property={'article:author'}
            content={author} />)}
        {seoType === 'article' && (<meta
            property={'article:published_time'}
            content={createdAt} />)}
        {seoType === 'article' && (<meta
            property={'article:modified_time'}
            content={updatedAt} />)}
    </Helmet>);
};

SEO.propTypes = {
    seoTitle: string,
    storeFaviconUrl: string,
    seoDescription: string,
    seoType: string,
    canonicalUrl: string,
    image: string,
    richSnippet: string,
    author: string,
    createdAt: string,
    updatedAt: string,
    pageContent: string,
    breadsArr: array,
};

export default SEO;